module.exports = __webpack_public_path__ + "img/mz.e99caf39.svg";